/** 判断事件目标是否处于应忽略全局快捷键的输入场景（与导航搜索一致） */
export function isEditableShortcutTarget (target: EventTarget | null): boolean {
  if (!target || !(target instanceof HTMLElement)) return false
  if (target.isContentEditable) return true
  const tag = target.tagName
  if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return true
  if (target.closest('[role="textbox"]')) return true
  return false
}

/** 仅 Shift，无 Ctrl / ⌘ / Alt（与导航搜索 Shift+F 一致） */
export function isPlainShiftChord (e: KeyboardEvent): boolean {
  return e.shiftKey && !e.ctrlKey && !e.metaKey && !e.altKey
}
